import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import TextButton from 'LuxKit/Button/TextButton'
import Typography from 'LuxKit/Typography/Typography'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyLandingPageBenefitsTable from './LoyaltyLandingPageBenefitsTable'
import { useLocation } from 'react-router'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;
  scroll-margin-top: 80px; /* Offset for sticky header */

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

interface Props {
  /**
   * Highlights the tiers row given (sets a background)
   */
  highlightTier?: App.LoyaltyTier
  onJoin?: () => void
  ctaLink?: string
  ctaText?: string
}

function LoyaltyLandingPageBenefitsTableSection(props: Props) {
  const { highlightTier, onJoin, ctaLink, ctaText = 'Join now - it\'s free' } = props
  const sectionRef = useRef<HTMLDivElement>(null)
  const location = useLocation()

  const showCta = onJoin || ctaLink

  useEffect(() => {
    if (location.hash === '#about-benefits' && sectionRef.current) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [location.hash])

  return <Section ref={sectionRef} id="about-benefits" paletteType="inverse">
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={72}>
        <LoyaltyLandingPageBenefitsTable highlightTier={highlightTier} />
        {showCta && <Typography align="center">
          <TextButton
            kind="primary"
            onClick={onJoin}
            to={ctaLink}
          >
            {ctaText}
          </TextButton>
        </Typography>}
      </Group>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageBenefitsTableSection
